export default __webpack_public_path__ + "static/media/Freedom-10eM.bfbf0996.ttf";